if (!customElements.get('meyspring-palette')) {
  customElements.define('meyspring-palette', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.selected = new Map();
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.submit = this.querySelector('[data-submit]');
      this.catalog = this.querySelector('[data-catalog]');
      this.catalogBase = this.catalog?.href;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.choices.forEach(button => button.addEventListener('click', () => {
        if (this.busy || this.submitted) return;
        if (this.selected.has(button.dataset.id)) this.selected.delete(button.dataset.id);
        else this.selected.set(button.dataset.id, button);
        this.update();
      }));
      if (this.dataset.fullPage === 'true') {
        const requested = new Set((new URL(window.location.href).searchParams.get('colors') || '').split(','));
        this.choices.forEach(button => {
          if (!button.disabled && requested.has(button.dataset.handle)) this.selected.set(button.dataset.id, button);
        });
      }
      this.filter = 'all';
      this.querySelector('[data-search]')?.addEventListener('input', () => this.filterChoices());
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.filterChoices();
      }));
      this.filterChoices();
      this.submit.addEventListener('click', () => this.addPalette());
      this.update();
    }
    filterChoices() {
      const term = (this.querySelector('[data-search]')?.value || '').trim().toLowerCase();
      let visible = 0;
      this.choices.forEach(button => {
        const matches = (this.filter === 'all' || button.dataset.kind === this.filter) && button.dataset.title.toLowerCase().includes(term);
        button.hidden = !matches;
        if (matches) visible++;
      });
      const status = this.querySelector('[data-filter-status]');
      if (status) status.textContent = this.messages.results.replace('[count]', visible);
    }
    setResponsiveText(element, desktopText, mobileText) {
      element.replaceChildren();
      if (!mobileText) {
        element.textContent = desktopText;
        return;
      }
      const desktop = document.createElement('span');
      desktop.className = 'ms-palette-desktop-copy';
      desktop.textContent = desktopText;
      const mobile = document.createElement('span');
      mobile.className = 'ms-palette-mobile-copy';
      mobile.textContent = mobileText;
      element.append(desktop, mobile);
    }
    update() {
      const count = this.selected.size;
      const selected = [...this.selected.values()];
      this.choices.forEach(button => button.setAttribute('aria-pressed', String(this.selected.has(button.dataset.id))));
      const countMessage = count >= 4 ? this.messages.count_ready || this.messages.count : count === 1 ? this.messages.count_one || this.messages.count : this.messages.count;
      const desktopCount = countMessage.replace('[count]', count).replace('[remaining]', Math.max(0, 4 - count));
      const mobileCount = count >= 4 ? this.messages.mobile_ready : this.messages.mobile_count?.replace('[count]', count);
      this.setResponsiveText(this.querySelector('[data-count]'), desktopCount, mobileCount);
      this.querySelector('[data-status]').textContent = count >= 4 ? this.messages.ready : count ? this.messages.remaining.replace('[count]',4-count) : this.messages.initial;
      const tray = this.querySelector('.ms-palette-tray');
      tray.replaceChildren();
      for (let index = 0; index < Math.max(4, count); index++) {
        const slot = document.createElement('div');
        slot.className = 'ms-palette-slot';
        const button = selected[index];
        const label = document.createElement('p');
        if (button) {
          const image = document.createElement('img');
          image.src = button.dataset.jar || button.querySelector('img').currentSrc || button.querySelector('img').src;
          image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.alt = '';
          image.loading = 'eager';
          slot.append(image); label.textContent = button.dataset.title;
          slot.classList.add('is-filled');
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'ms-palette-remove'; remove.textContent = '×';
          remove.setAttribute('aria-label', this.messages.remove.replace('[title]', button.dataset.title));
          remove.addEventListener('click', () => {
            if (this.busy || this.submitted) return;
            this.selected.delete(button.dataset.id); this.update();
            const next = this.querySelector('.ms-palette-remove');
            if (next) next.focus(); else if (!button.hidden) button.focus();
          });
          slot.append(remove);
        } else {
          const number = document.createElement('span'); number.textContent = String(index+1).padStart(2,'0');
          slot.append(number); label.textContent = this.messages.choose;
        }
        slot.append(label); tray.append(slot);
      }
      if (this.catalog) {
        const destination = new URL(this.catalogBase);
        if (count) destination.searchParams.set('colors', selected.map(button => button.dataset.handle).join(','));
        else destination.searchParams.delete('colors');
        this.catalog.href = destination.href;
      }
      const total = selected.reduce((sum,button) => sum+Number(button.dataset.price),0);
      const output = this.querySelector('[data-total]'); output.replaceChildren();
      if (total) {
        if (count >= 4) {const old=document.createElement('s'); old.textContent=this.money.format(total/100); output.append(old);}
        const value=document.createElement('strong'); value.textContent=this.money.format((count>=4?Math.round(total*.8):total)/100); output.append(value);
        if (count >= 4) {const label=document.createElement('small'); label.textContent=this.messages.estimate; output.append(label);}
      }
      this.submit.disabled = count < 4;
      this.setResponsiveText(this.submit, count >= 4 ? this.messages.add : this.messages.choose_four, count >= 4 ? this.messages.mobile_add : this.messages.mobile_choose);
    }
    async addPalette() {
      if (this.submitted) {window.location.assign(this.dataset.cart); return;}
      if (this.busy || this.selected.size < 4) return;
      this.busy=true; this.submit.disabled=true; this.submit.textContent=this.messages.adding;
      this.setAttribute('aria-busy','true'); this.querySelector('[data-error]').hidden=true;
      try {
        const root=window.Shopify?.routes?.root || this.dataset.root.replace(/\/?$/,'/');
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...this.selected.keys()].map(id=>({id:Number(id),quantity:1}))})});
        const result=await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.messages.error);
        this.submitted=true;
        const discount=new URL(root+'discount/'+encodeURIComponent(this.dataset.code),window.location.origin);
        discount.searchParams.set('redirect',this.dataset.cart);
        window.location.assign(discount.toString());
      } catch(error) {
        this.submitted=true;
        const output=this.querySelector('[data-error]'); output.textContent=this.messages.error+(error.message && error.message!==this.messages.error?' '+error.message:''); output.hidden=false;
        this.submit.textContent=this.messages.in_cart; this.submit.disabled=false;
      } finally {this.busy=false; this.removeAttribute('aria-busy');}
    }
  });
}
if (!customElements.get('meyspring-calculator')) {
  customElements.define('meyspring-calculator', class extends HTMLElement {
    connectedCallback(){
      if(this.initialized)return;this.initialized=true;
      const input=this.querySelector('input');
      input.addEventListener('input',()=>{
        const oz=Number(input.value);const valid=input.value!=='' && Number.isFinite(oz) && oz>=.1 && oz<=10000;
        this.querySelector('[data-result]').textContent=valid?new Intl.NumberFormat(document.documentElement.lang || 'en',{maximumFractionDigits:2}).format(oz*.5)+'g':'—';
        input.setAttribute('aria-invalid',String(!valid));
      });
    }
  });
}
